import { render, staticRenderFns } from "./EducationEventList.vue?vue&type=template&id=1748a551&"
import script from "./EducationEventList.vue?vue&type=script&lang=ts&"
export * from "./EducationEventList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports